/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify,
 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './default-layout';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { UnauthorizedComponent } from './views/error/unauthorized.component';
import { LogoffComponent } from './views/logoff/logoff.component';
import { LoginComponent } from './views/auth/login/login.component';
import { SignupComponent } from './views/auth/signup/signup.component';
import {DashboardComponent} from './views/dashboard/dashboard.component'
import { IntradayComponent } from './Intraday_Table/Intraday.component';
import { ForgetPasswordComponent } from './views/auth/ForgetPassword/ForgetPassword.component';
import { LandingPageComponent } from './landing-page/landing-page.component';

import { detailsInstrumentRoutingModule } from './detailsInstrument/detailsInstrument-routing.module';
import { ActivationPageComponent } from './views/auth/activation-page/activation-page.component';
import { ResetemailComponent } from './views/auth/resetemail/resetemail.component';
import { SubscriptionPlansComponent } from './payment/subscription-plans/subscription-plans.component';
import { PaymentformComponent } from './payment/paymentform/paymentform.component';
import { FuseSharedModule } from '../@fuse/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { FakeDbService } from './fake-db/fake-db.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LayoutModule } from '@angular/cdk/layout';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '../@fuse/components';
import { FuseModule } from '../@fuse/fuse.module';
import { fuseConfig } from './fuse-config';
import { AppStoreModule } from './store/store.module';
import { CreateProfileComponent } from './admin/CreateProfile/CreateProfile.component';
import { AdminAuthGuard, CognitoGuard } from './cognito.guard';




export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
    
  },

  {
   path: 'reset',
    component: ResetemailComponent,
    data: {
      title: 'Forget Password   Page'
    }
    
  },
  {
    path: 'login',
    component: LoginComponent
    
  },
  {
    path: 'Subscription',
    component: SubscriptionPlansComponent
    
  },

  {
    path: 'payment',
    component: PaymentformComponent
    
  },
  {
    path: 'confirm/:activationCode',
    component: ActivationPageComponent
    
  },
  {
    path: 'signup',
    component: SignupComponent,
    data: {
      title: 'Signup  Page'
    }
    
  },

  {
    path: 'ForgetPassword/:activationCode/:email',
    component: ForgetPasswordComponent,
    data: {
      title: 'Forget Password   Page'
    }
    
  },


  {
    path: 'Dashboard',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },

  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'Profilee',
    component:CreateProfileComponent,
    data: {
      title: 'profile  Page'
    }
    

  },
  {
    path: 'logoff',
    component: LogoffComponent,
    data: {
      title: 'Logoff Page'
    }
  },



  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule)
      },
      
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)

      },

      {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'intradays',
        loadChildren: () => import('./intradays/intradays.module').then(m => m.IntradayModule)
      },
      {
        path: 'opcvms',
        loadChildren: () => import('./opcvms/opcvms.module').then(m => m.OPCVMModule)
      },
      {
        path: 'table',
        loadChildren: () => import('./Intraday_Table/intraday.module').then(m => m.Intraday_Table_Module)
      },
      {
        path: 'marche',
        loadChildren: () => import('./marche/marche.module').then(m => m.Marche_Module)
      }
      ,
      {
        path: 'opcvmtable',
        loadChildren: () => import('./opcvmstable/opcvms.module').then(m => m.OPCVMModule)
      } ,
      {
        path: 'opcvmtableGroupe',
        loadChildren: () => import('./opcvmsTableGroupe/opcvms.module').then(m => m.OPCVMModule)
      } ,
      
      {
        path: 'opcvmdetail',
        loadChildren: () => import('./opcvm_Detail/opcvm_detail.module').then(m => m.OPCVMDetailModule)
      },
      {
        path: 'dashbordcompte',
        loadChildren: () => import('./dashboardCompte/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashbordalgog',
        loadChildren: () => import('./dashbordAlgoG/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashbordModels',
        loadChildren: () => import('./dashbordModels/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashbordPredictions',
        loadChildren: () => import('./dashbordPredictions/dashboardPredictions.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashbordalgogtop',
        loadChildren: () => import('./dashbordAlgoGTop/dashboard.module').then(m => m.DashboardModule)
      },
      // {
      //   path: 'Tech_Fond',
      //   loadChildren: () => import('./Fondamentale/dashboard.module').then(m => m.DashboardModule)
      // },
      {
        path: 'Histo_prediction',
        loadChildren: () => import('./Historique_Prediction_Instrument/intradays.module').then(m => m.IntradayModule)
      }
    ,
      {
        path: 'articles',
        loadChildren: () => import('./article/article.module').then(m => m.Article_Module)
      }
      ,
      {
        path: 'detailInstrument',
        loadChildren: () => import('./detailsInstrument/detailsInstrument.module').then(m => m.detailInstrumentModule)
      }
      ,
      {
        path: 'detailInstrument',
        loadChildren: () => import('./detailsInstrument/detailsInstrument.module').then(m => m.detailInstrumentModule)
      }
      ,
      {
        path: 'Profile',
        loadChildren: () => import('./views/auth/profile/profile.module').then(m => m.profile_Module)
      }
      ,

      {
        path: 'profilesecurity',
        loadChildren: () => import('./views/auth/profile-security/profile-security.module').then(m => m.profilesecurity_Module)
      }
      ,
      {
        path: 'support',
        loadChildren: () => import('./views/auth/support/support.module').then(m => m.support_Module)
      }
      ,

      {
        path: 'accountbilling',
        loadChildren: () => import('./payment/accountbilling/accountbilling.module').then(m => m.AccountBilling_Module)
      }
      ,
      {
        path: 'e-commerce',
        loadChildren: () => import('./payment/e-commerce/e-commerce.module').then(m => m.EcommerceModule),
        canActivate: [AdminAuthGuard]
      }
      ,
      
      {
        path: 'clients',
        loadChildren: () => import('./admin/contacts/contacts.module').then(m => m.ContactsModule),
        canActivate: [AdminAuthGuard]
      }
      ,{
        path: 'alerts',
        loadChildren: () => import('./admin/Alerts/Alert.module').then(m => m.OPTestModule),
        canActivate: [AdminAuthGuard]
      },
      {
        path: 'opcvmss',
        loadChildren: () => import('./admin/opcvms/opc.module').then(m => m.OPTestModule),
        canActivate: [AdminAuthGuard]
      }
      ,      
      {
        path: 'dashboard',
        loadChildren: () => import('./admin/dashboard-clients/dashboard-clients.module').then(m => m.DashboardClientsComponent_Module)
      },
      {
        path: 'dashboards',
        loadChildren: () => import('./admin/dashboard-sales/dashboard-sales.module').then(m => m.DashboardSalesComponent_Module),
        canActivate: [AdminAuthGuard]
      },
      {
        path: 'profiles',
        loadChildren: () => import('./admin/analizeClient/analizeClient.module').then(m => m.AnalizeClientComponent_Module),
        canActivate: [AdminAuthGuard]
      },
      {
        path: 'Tech_Fond',
        loadChildren: () => import('./dashbordModels_Tech_Fond/dashboard.module').then(m => m.DashboardModule)
      },

      {
        path: 'Historique_Tech_Fond',
        loadChildren: () => import('./dashbordModels_Historique_Tech_Fond/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'Historique_Fondamentale',
        loadChildren: () => import('./Historique_Fondamentale/dashboard.module').then(m => m.DashboardModule)
      }, {
        path: 'dashbordModels_1',
        loadChildren: () => import('./Fondamentale/dashboard.module').then(m => m.DashboardModule)
      },



    ],
  },
  
 

  {
    path: 'unauthorized',
    component: UnauthorizedComponent,

 

  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes),
    FuseSharedModule,
    HttpClientModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),

    TranslateModule.forRoot(),
    InMemoryWebApiModule.forRoot(FakeDbService, {
        delay             : 0,
        passThruUnknownUrl: true
    }),
    MatMomentDateModule,
    MatButtonModule,
    MatIconModule,
     FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        AppStoreModule
      
],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
